import { defineMessages } from 'react-intl';

export default defineMessages({
  required: {
    description: 'mapOrderImportModal.required',
    defaultMessage: '(required)',
    id: 'YKboqu',
  },
  mappingsDropdownDefaultOption: {
    description: 'mappingsDropdown.selectOne',
    defaultMessage: 'Select One',
    id: 'Pr753u',
  },
  'Order #': {
    description: 'mapOrderImportModal.cols.orderNumber',
    defaultMessage: 'Order #',
    id: '3gzO5g',
  },
  'Order Date': {
    description: 'mapOrderImportModal.cols.orderDate',
    defaultMessage: 'Order Date',
    id: 'JYT8zE',
  },
  'Date Paid': {
    description: 'mapOrderImportModal.cols.payDate',
    defaultMessage: 'Date Paid',
    id: 'qtnimB',
  },
  'Order Total': {
    description: 'mapOrderImportModal.cols.orderTotal',
    defaultMessage: 'Order Total',
    id: 'GQeG70',
  },
  'Amount Paid': {
    description: 'mapOrderImportModal.cols.amountPaid',
    defaultMessage: 'Amount Paid',
    id: '1pu+BX',
  },
  Tax: {
    description: 'mapOrderImportModal.cols.tax',
    defaultMessage: 'Tax',
    id: '5bHxiR',
  },
  'Shipping Paid': {
    description: 'mapOrderImportModal.cols.shippingAmount',
    defaultMessage: 'Shipping Paid',
    id: 'v7xV35',
  },
  'Shipping Service': {
    description: 'mapOrderImportModal.cols.shippingService',
    defaultMessage: 'Shipping Service',
    id: 'kA6QBL',
  },
  'Weight(gr)': {
    description: 'mapOrderImportModal.cols.weight',
    defaultMessage: 'Weight(gr)',
    id: 'VNXsu+',
  },
  'Height(cm)': {
    description: 'mapOrderImportModal.cols.height',
    defaultMessage: 'Height(cm)',
    id: 'F93FnT',
  },
  'Width(cm)': {
    description: 'mapOrderImportModal.cols.width',
    defaultMessage: 'Width(cm)',
    id: 'k1gwNc',
  },
  'Length(cm)': {
    description: 'mapOrderImportModal.cols.length',
    defaultMessage: 'Length(cm)',
    id: '5ofX2o',
  },
  'Custom Field 1': {
    description: 'mapOrderImportModal.cols.customField1',
    defaultMessage: 'Custom Field 1',
    id: '+G8Pjv',
  },
  'Custom Field 2': {
    description: 'mapOrderImportModal.cols.customField2',
    defaultMessage: 'Custom Field 2',
    id: 'WFX595',
  },
  'Custom Field 3': {
    description: 'mapOrderImportModal.cols.customField3',
    defaultMessage: 'Custom Field 3',
    id: 'A/zDsO',
  },
  'Order Source': {
    description: 'mapOrderImportModal.cols.source',
    defaultMessage: 'Order Source',
    id: 'pGLyDb',
  },
  'Buyer Full Name': {
    description: 'mapOrderImportModal.cols.buyerName',
    defaultMessage: 'Buyer Full Name',
    id: 'TSznwx',
  },
  'Buyer First Name': {
    description: 'mapOrderImportModal.cols.buyerFirstName',
    defaultMessage: 'Buyer First Name',
    id: '/nKP1j',
  },
  'Buyer Last Name': {
    description: 'mapOrderImportModal.cols.buyerLastName',
    defaultMessage: 'Buyer Last Name',
    id: 'eu9Qms',
  },
  'Buyer Email': {
    description: 'mapOrderImportModal.cols.email',
    defaultMessage: 'Buyer Email',
    id: '1oWG+F',
  },
  'Buyer Phone': {
    description: 'mapOrderImportModal.cols.phone',
    defaultMessage: 'Buyer Phone',
    id: '2ANTU5',
  },
  'Buyer Username': {
    description: 'mapOrderImportModal.cols.userName',
    defaultMessage: 'Buyer Username',
    id: 'hSuqo4',
  },
  'Recipient Full Name': {
    description: 'mapOrderImportModal.cols.name',
    defaultMessage: 'Recipient Full Name',
    id: 'u/T4f5',
  },
  'Recipient First Name': {
    description: 'mapOrderImportModal.cols.firstName',
    defaultMessage: 'Recipient First Name',
    id: 'N1Nqun',
  },
  'Recipient Last Name': {
    description: 'mapOrderImportModal.cols.lastName',
    defaultMessage: 'Recipient Last Name',
    id: 'wTZd/S',
  },
  'Recipient Phone': {
    description: 'mapOrderImportModal.cols.recipientPhone',
    defaultMessage: 'Recipient Phone',
    id: 'ANx9RZ',
  },
  'Recipient Company': {
    description: 'mapOrderImportModal.cols.company',
    defaultMessage: 'Recipient Company',
    id: '7zjsaI',
  },
  'Address Line 1': {
    description: 'mapOrderImportModal.cols.address1',
    defaultMessage: 'Address Line 1',
    id: 'aogUJr',
  },
  'Address Line 2': {
    description: 'mapOrderImportModal.cols.address2',
    defaultMessage: 'Address Line 2',
    id: '6EaCbx',
  },
  'Address Line 3': {
    description: 'mapOrderImportModal.cols.address3',
    defaultMessage: 'Address Line 3',
    id: 'kmOCu4',
  },
  City: {
    description: 'mapOrderImportModal.cols.city',
    defaultMessage: 'City',
    id: 'onSZ3M',
  },
  State: {
    description: 'mapOrderImportModal.cols.state',
    defaultMessage: 'State',
    id: 'Et6PBC',
  },
  'Postal Code': {
    description: 'mapOrderImportModal.cols.postalCode',
    defaultMessage: 'Postal Code',
    id: 'if/bJU',
  },
  'Country Code': {
    description: 'mapOrderImportModal.cols.countryCode',
    defaultMessage: 'Country Code',
    id: 'MmV/55',
  },
  'Item SKU': {
    description: 'mapOrderImportModal.cols.itemSku',
    defaultMessage: 'Item SKU',
    id: 'n9CK+L',
  },
  'Item Name / Title': {
    description: 'mapOrderImportModal.cols.itemName',
    defaultMessage: 'Item Name / Title',
    id: 'RBY4DE',
  },
  'Item Quantity': {
    description: 'mapOrderImportModal.cols.itemQuantity',
    defaultMessage: 'Item Quantity',
    id: '6zacSW',
  },
  'Item Unit Price': {
    description: 'mapOrderImportModal.cols.itemUnitPrice',
    defaultMessage: 'Item Unit Price',
    id: 't/x0vm',
  },
  'Item Weight (gr)': {
    description: 'mapOrderImportModal.cols.itemWeight',
    defaultMessage: 'Item Weight (gr)',
    id: 'Ywi6JU',
  },
  'Item Options': {
    description: 'mapOrderImportModal.cols.itemOptions',
    defaultMessage: 'Item Options',
    id: 'qSqsXV',
  },
  'Item Warehouse Location': {
    description: 'mapOrderImportModal.cols.itemWarehouseLocation',
    defaultMessage: 'Item Warehouse Location',
    id: '3XQ/oJ',
  },
  'Item Marketplace ID': {
    description: 'mapOrderImportModal.cols.itemExternalID',
    defaultMessage: 'Item Marketplace ID',
    id: 'CudlY3',
  },
  'Notes from the Buyer': {
    description: 'mapOrderImportModal.cols.notesFromBuyer',
    defaultMessage: 'Notes from the Buyer',
    id: 'ZCF4b+',
  },
  'Notes to the Buyer': {
    description: 'mapOrderImportModal.cols.notesToBuyer',
    defaultMessage: 'Notes to the Buyer',
    id: 'zh84pE',
  },
  'Internal Notes': {
    description: 'mapOrderImportModal.cols.internalNotes',
    defaultMessage: 'Internal Notes',
    id: 'VEZi+l',
  },
  'Gift Message': {
    description: 'mapOrderImportModal.cols.giftMessage',
    defaultMessage: 'Gift Message',
    id: 'rSVkNm',
  },
  'Gift Flag': {
    description: 'mapOrderImportModal.cols.gift',
    defaultMessage: 'Gift Flag',
    id: 'B70wPD',
  },
  'Order Custom Field 1': {
    description: 'mapOrderImportModal.cols.orderCustomField1',
    defaultMessage: 'Order Custom Field 1',
    id: 'JgUhlr',
  },
  'Order Custom Field 2': {
    description: 'mapOrderImportModal.cols.orderCustomField2',
    defaultMessage: 'Order Custom Field 2',
    id: 'sCN37l',
  },
  'Order Custom Field 3': {
    description: 'mapOrderImportModal.cols.orderCustomField3',
    defaultMessage: 'Order Custom Field 3',
    id: 'C8nKJZ',
  },
  'Order Number': {
    description: 'mapOrderImportModal.cols.order Number',
    defaultMessage: 'Order Number',
    id: '8LgGPx',
  },
  'Order Created Date': {
    description: 'mapOrderImportModal.cols.order Created Date',
    defaultMessage: 'Order Created Date',
    id: 'KMSkbo',
  },
  'Order Date Paid': {
    description: 'mapOrderImportModal.cols.order Date Paid',
    defaultMessage: 'Order Date Paid',
    id: 'I3Z9jZ',
  },
  'Order Amount Paid': {
    description: 'mapOrderImportModal.cols.order Amount Paid',
    defaultMessage: 'Order Amount Paid',
    id: '0OhINX',
  },
  'Order Tax Paid': {
    description: 'mapOrderImportModal.cols.order Tax Paid',
    defaultMessage: 'Order Tax Paid',
    id: 'H+arCr',
  },
  'Order Shipping Paid': {
    description: 'mapOrderImportModal.cols.order Shipping Paid',
    defaultMessage: 'Order Shipping Paid',
    id: 'ikToO5',
  },
  'Order Requested Shipping Service': {
    description: 'mapOrderImportModal.cols.order Requested Shipping Service',
    defaultMessage: 'Order Requested Shipping Service',
    id: '/UZfR0',
  },
  'Order Total Weight (oz)': {
    description: 'mapOrderImportModal.cols.order Total Weight (oz)',
    defaultMessage: 'Order Total Weight (oz)',
    id: 'l/+7lV',
  },
  'Order Notes from Buyer': {
    description: 'mapOrderImportModal.cols.order Notes from Buyer',
    defaultMessage: 'Order Notes from Buyer',
    id: 'Sh1Bzh',
  },
  'Order Notes to Buyer': {
    description: 'mapOrderImportModal.cols.order Notes to Buyer',
    defaultMessage: 'Order Notes to Buyer',
    id: 'yt1zBo',
  },
  'Order Internal Notes': {
    description: 'mapOrderImportModal.cols.order Internal Notes',
    defaultMessage: 'Order Internal Notes',
    id: '6HKp5n',
  },
  'Order Gift Message': {
    description: 'mapOrderImportModal.cols.order Gift Message',
    defaultMessage: 'Order Gift Message',
    id: 'ysrURk',
  },
  'Order Gift - Flag': {
    description: 'mapOrderImportModal.cols.order Gift - Flag',
    defaultMessage: 'Order Gift - Flag',
    id: 'mbEanC',
  },
  'Item Name': {
    description: 'mapOrderImportModal.cols.item Name',
    defaultMessage: 'Item Name',
    id: '5JEK9/',
  },
  'Item Weight (oz)': {
    description: 'mapOrderImportModal.cols.item Weight (oz)',
    defaultMessage: 'Item Weight (oz)',
    id: 'IbhcvX',
  },
});
